module.exports = __webpack_public_path__ + "static/media/user.1137e734.jpeg";